import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gvjwg3hjh3: FaireBrandEntity = {
  token: "b_gvjwg3hjh3",
  type: "brand",
  name: "Prairie City Printing Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/1fb2db035b6bfe68b3873a15b464dd8097f460fe445b3edc68242b6dc949bfcb.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4b3a95eadf35f8b58bb9199193e5e5185a2b38c95a00f4f2317763e82c4eb942.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1fb2db035b6bfe68b3873a15b464dd8097f460fe445b3edc68242b6dc949bfcb.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4b3a95eadf35f8b58bb9199193e5e5185a2b38c95a00f4f2317763e82c4eb942.png",
  location: "Winnipeg, MB, CAN",
  minimumOrderDollars: 115,
  rating: 4.7,
  reviewCount: 10,
  isTopShop: true,
  isInsider: false,
  description:
    "Hey! Welcome to our shop!\n\nAt Prairie City Printing Co. we specialize in 3D printed planter pots, vases and other home decor items made out of eco-friendly plant-based PLA materials. The materials are made from corn and sugarcane and are fully biodegradable. \n\nWe are a husband and wife duo; John and Jenn. Starting this journey back in 2022, we quickly realized we have a knack for designing and creating unique plant pots and functional decor pieces of all shapes and sizes. \n\nSince then, we have been adding to our product line which has expanded from plant pots to a full line of home goods including our top selling Pet Bowls. We work with a new rescue each month and a portion of each purchase is donated to them. \n\nThank you for visiting our shop.\n\nLocated in the heart of 🇨🇦 in Winnipeg, Mb. \n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:43.246Z",
    importedBy: "entity-db-cli",
  },
};
